<template>
    <main class="main-content">

        <section class="hero is-fullheight">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-multiline is-mobile has-items-center">
                        <div class="column is-full-mobile is-4">
                            <h1 class="is-size-1 has-text-danger is-uppercase">Error: 404</h1>
                            <h3>Content not found</h3>
                        </div>
                        <div class="column is-full-mobile is-8 has-text-justified">
                            <p>The content you are looking for is no more available. Please use the menu on top to find
                                what your looking for.</p>
                            <p>If your from Japan, please visit our partners website: <a
                                    href="http://www.draftwine.co.jp/" target="_blank">www.draftwine.co.jp</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </main>
</template>
<script>
    export default {
        metaInfo() {
            return {
                title: this.$t('seo.about.title'),
                meta: [
                    {name: 'title', content: this.$t('seo.about.title')},
                    {name: 'description', content: this.$t('seo.about.description')}
                ]
            }
        }
    }
</script>